(() => {
	const ratingFormTemplate = `
    <div class="w-content-rating my-4">
      <div class="container">
        <form class="content-rating-form js-content-rating-form mt-6" method="post" novalidate>
          <strong class="form-group-label">Tell us what you think</strong><br />

          <div class="content-rating-form__comments js-content-rating-comments">
            <div class="form-group">
              <label for="content-rating-comments"><strong>How can we make the information on this page easier to find, use, and understand?</strong></label>
              <textarea class="form-control mb-3" id="content-rating-comments" rows="4"></textarea>
            </div>
          </div>

          <div class="content-rating-form__ratings-wrapper">
            <label class="content-rating-form__ratings-label"><strong>Select your rating</strong></label>
            <div class="content-rating-form__ratings 5 js-content-rating-values">
              <input checked value="0" id="star0" type="radio" name="rating" class="visually-hidden" />
              <label for="star0">
                <span class="visually-hidden">0 Stars</span>
                <svg viewBox="0 0 512 512">
                  <g stroke-width="70" stroke-linecap="square">
                    <path d="M91.5,442.5 L409.366489,124.633512"></path>
                    <path d="M90.9861965,124.986197 L409.184248,443.184248"></path>
                  </g>
                </svg>
              </label>
              <input value="1" id="star1" type="radio" name="rating" class="visually-hidden" />
              <label for="star1"><span class="visually-hidden">1 Star</span><svg viewBox="0 0 36 36"><path class="svg-star-path-body" d="M21.89,15,18,2.19,14.12,15H2l9.89,7.06L8.13,34.19,18,26.69l9.89,7.5L24.13,22.05,34,15Z"></path><path class="svg-star-path-border" d="M18,9.07l2,6.5L20.4,17h7.36L23,20.42l-1.18.84.43,1.38,1.92,6.19-4.93-3.74L18,24.17l-1.21.92-4.91,3.73,1.92-6.18.43-1.38-1.18-.84L8.25,17H15.6L16,15.57l2-6.5m0-6.88L14.12,15H2l9.89,7.06L8.13,34.19,18,26.69l9.89,7.5L24.13,22.05,34,15H21.89L18,2.19Z"></path></svg></label>
              <input value="2" id="star2" type="radio" name="rating" class="visually-hidden" />
              <label for="star2"><span class="visually-hidden">2 Stars</span><svg viewBox="0 0 36 36"><path class="svg-star-path-body" d="M21.89,15,18,2.19,14.12,15H2l9.89,7.06L8.13,34.19,18,26.69l9.89,7.5L24.13,22.05,34,15Z"></path><path class="svg-star-path-border" d="M18,9.07l2,6.5L20.4,17h7.36L23,20.42l-1.18.84.43,1.38,1.92,6.19-4.93-3.74L18,24.17l-1.21.92-4.91,3.73,1.92-6.18.43-1.38-1.18-.84L8.25,17H15.6L16,15.57l2-6.5m0-6.88L14.12,15H2l9.89,7.06L8.13,34.19,18,26.69l9.89,7.5L24.13,22.05,34,15H21.89L18,2.19Z"></path></svg></label>
              <input value="3" id="star3" type="radio" name="rating" class="visually-hidden" />
              <label for="star3"><span class="visually-hidden">3 Stars</span><svg viewBox="0 0 36 36"><path class="svg-star-path-body" d="M21.89,15,18,2.19,14.12,15H2l9.89,7.06L8.13,34.19,18,26.69l9.89,7.5L24.13,22.05,34,15Z"></path><path class="svg-star-path-border" d="M18,9.07l2,6.5L20.4,17h7.36L23,20.42l-1.18.84.43,1.38,1.92,6.19-4.93-3.74L18,24.17l-1.21.92-4.91,3.73,1.92-6.18.43-1.38-1.18-.84L8.25,17H15.6L16,15.57l2-6.5m0-6.88L14.12,15H2l9.89,7.06L8.13,34.19,18,26.69l9.89,7.5L24.13,22.05,34,15H21.89L18,2.19Z"></path></svg></label>
              <input value="4" id="star4" type="radio" name="rating" class="visually-hidden" />
              <label for="star4"><span class="visually-hidden">4 Stars</span><svg viewBox="0 0 36 36"><path class="svg-star-path-body" d="M21.89,15,18,2.19,14.12,15H2l9.89,7.06L8.13,34.19,18,26.69l9.89,7.5L24.13,22.05,34,15Z"></path><path class="svg-star-path-border" d="M18,9.07l2,6.5L20.4,17h7.36L23,20.42l-1.18.84.43,1.38,1.92,6.19-4.93-3.74L18,24.17l-1.21.92-4.91,3.73,1.92-6.18.43-1.38-1.18-.84L8.25,17H15.6L16,15.57l2-6.5m0-6.88L14.12,15H2l9.89,7.06L8.13,34.19,18,26.69l9.89,7.5L24.13,22.05,34,15H21.89L18,2.19Z"></path></svg></label>
              <input value="5" id="star5" type="radio" name="rating" class="visually-hidden" />
              <label for="star5"><span class="visually-hidden">5 Stars</span><svg viewBox="0 0 36 36"><path class="svg-star-path-body" d="M21.89,15,18,2.19,14.12,15H2l9.89,7.06L8.13,34.19,18,26.69l9.89,7.5L24.13,22.05,34,15Z"></path><path class="svg-star-path-border" d="M18,9.07l2,6.5L20.4,17h7.36L23,20.42l-1.18.84.43,1.38,1.92,6.19-4.93-3.74L18,24.17l-1.21.92-4.91,3.73,1.92-6.18.43-1.38-1.18-.84L8.25,17H15.6L16,15.57l2-6.5m0-6.88L14.12,15H2l9.89,7.06L8.13,34.19,18,26.69l9.89,7.5L24.13,22.05,34,15H21.89L18,2.19Z"></path></svg></label>
            </div>
          </div>

          <div class="js-content-rating-followup" style="display: none">
            <div class="content-rating-form__help">
              <div class="form-group">
                <label class="content-rating-form__help-label"><strong>How did this information help you (click all that apply):</strong></label>
                <div class="content-rating-form__help-options">
                  <label class="content-rating-form__help-option"><input class="mb-0" type="checkbox" name="helpReasons" value="I understand this topic better" /> <span>I understand this topic better</span></label>
                  <label class="content-rating-form__help-option"><input class="mb-0" type="checkbox" name="helpReasons" value="I know what I can do next" /> <span>I know what I can do next</span></label>
                  <label class="content-rating-form__help-option"><input class="mb-0" type="checkbox" name="helpReasons" value="I feel better prepared to make decisions" /> <span>I feel better prepared to make decisions</span></label>
                  <label class="content-rating-form__help-option"><input class="mb-0" type="checkbox" name="helpReasons" value="I know what questions I want to ask my healthcare team" /> <span>I know what questions I want to ask my healthcare team</span></label>
                  <label class="content-rating-form__help-option"><input class="mb-0" type="checkbox" name="helpReasons" value="The information reduced my worry" /> <span>The information reduced my worry</span></label>
                </div>
              </div>
            </div>

            <div class="content-rating-form__email">
              <div class="form-group">
                <label for="content-rating-email"><strong>Your email address (optional)</strong></label>
                <input class="form-control" id="content-rating-email" type="email" name="email" autocomplete="email" maxlength="255" />
              </div>
            </div>

            <div class="content-rating-form__audience js-content-rating-audience">
              <div class="form-group">
                <label class="content-rating-form__audience-label"><strong>Thank you for your feedback, can you tell us if you are:</strong></label>
                <div class="content-rating-form__audience-options">
                  <label class="content-rating-form__audience-option"><input class="mb-0" type="radio" id="patient" name="audience" value="a person living with MND" /> <span>a person living with MND</span></label>
                  <label class="content-rating-form__audience-option"><input class="mb-0" type="radio" id="family" name="audience" value="a carer/family member of someone with MND" /> <span>a carer/family member of someone with MND</span></label>
                  <label class="content-rating-form__audience-option"><input class="mb-0" type="radio" id="professional" name="audience" value="a health professional or service provider" /> <span>a health professional or service provider</span></label>
                  <label class="content-rating-form__audience-option"><input class="mb-0" type="radio" id="other" name="audience" value="other" /> <span>other</span></label>
                </div>
              </div>
            </div>
          </div>

          <div class="content-rating-form__submit js-content-rating-submit" style="display: none">
            <button type="submit" class="btn btn-outline btn-blue" disabled>Send rating</button>
          </div>
        </form>

        <div class="content-rating__success-notification js-content-rating-success" style="display: none">
          <strong class="form-group-label">Tell us what you think</strong><br />
          <p>Thank you for your feedback.</p>
        </div>
      </div>
    </div>
  `;

	function togglePostRatingFields($container, show) {
		const $followUp = $container.find(".js-content-rating-followup");
		const $submit = $container.find(".js-content-rating-submit");

		$followUp.find("input").prop("disabled", !show);
		$submit.find("button").prop("disabled", !show);

		if (show) {
			$followUp.show();
			$submit.show();
			return;
		}

		$followUp.find("input[name='audience']").prop("checked", false);
		$followUp.find("input[name='helpReasons']").prop("checked", false);
		$followUp.find("#content-rating-email").val("");
		$followUp.hide();
		$submit.hide();
	}

	function initPageRating($mount) {
		const endpoint = $mount.data("content-rating-endpoint");
		const documentGuid = $mount.data("document-guid");
		const documentVersion = $mount.data("document-version");
		const contactGuid = $mount.data("contact-guid");

		$mount.html(ratingFormTemplate);

		const $form = $mount.find(".js-content-rating-form");
		const $success = $mount.find(".js-content-rating-success");

		togglePostRatingFields($mount, false);

		$form.on("change", "input[name='rating']", function () {
			const rating = Number($(this).val() || 0);
			togglePostRatingFields($mount, rating > 0);
		});

		$form.on("submit", function (event) {
			event.preventDefault();

			const rating = Number($form.find("input[name='rating']:checked").val() || 0);
			const comments = $form.find("#content-rating-comments").val();
			const audience = $form.find("input[name='audience']:checked").val() || null;
			const helpReasons = $form.find("input[name='helpReasons']:checked")
				.map(function () {
					return this.value;
				})
				.get()
				.join("\n");
			const email = ($form.find("#content-rating-email").val() || "").trim();

			if (rating <= 0) {
				return;
			}

			$form[0].setAttribute("data-form-submit-loading-keep", "true");

			let submitted = false;
			const submitRating = function () {
				if (submitted) {
					return;
				}
				submitted = true;

				const turnstileToken = $form.find("input[name='cf-turnstile-response']").val() || "";

				$.ajax({
					type: "POST",
					url: endpoint,
					dataType: "json",
					data: {
						rating,
						comments,
						audience,
						helpReasons,
						email,
						documentGuid,
						documentVersion,
						contactGuid,
						turnstileResponse: turnstileToken,
					},
					success: function () {
						$form.hide();
						$success.show();
					},
					complete: function () {
						if (window.MNDFormSubmitLoading) {
							window.MNDFormSubmitLoading.hide($form[0]);
						}
					},
				});
			};

			if (window.MNDTurnstile && typeof window.MNDTurnstile.runWhenReady === "function") {
				window.MNDTurnstile.runWhenReady(submitRating);
				return;
			}

			submitRating();
		});
	}

	$(document).ready(function () {
		$("[data-page-rating-component='content-rating-form']").each(function () {
			initPageRating($(this));
		});
	});
})();
